document.querySelectorEver = (function() {
        let loaded = false;
        const selectors = [];
        const registerSelector = (selector, __callback) => {
          if (!typeof __callback == 'function') throw new TypeError('could not execute wheneverExist: You need to pass a callback function as the second paramater');
          selectors.push([selector, __callback]);


          if (loaded) document.querySelectorAll(selector).forEach(element => __callback(element));
        };  


        const observer = new MutationObserver((mutationsList, observer) => {
          for(const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(node => {
                if (node instanceof Element) {
                  for (const selectorEntry of selectors) {
                    const [selector, __callback] = selectorEntry;
                    const elements = (node.matches(selector) && [node]) || node.querySelectorAll(selector);
                    if (elements) elements.forEach(element => __callback(element));
                  }
                }
              });
            }
          }
        });


        window.addEventListener('DOMContentLoaded', _ => {
          loaded = true;
          for (const selectorEntry of selectors) document.querySelectorAll(selectorEntry[0]).forEach(element => selectorEntry[1](element));
          observer.observe(document.body, { childList: true, subtree: true });
        });
        
        return registerSelector;
      })();